module.exports = __webpack_public_path__ + "img/estimated-insurance-required-input.adcb01e9.png";